import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import ValidityAdornment from './ValidityAdornment';

const NotifyContentLabel = ({ contentValidity }) => {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex' }}>
      <Typography
        color={contentValidity.contentIsEmpty ? 'error' : 'textSecondary'}
        style={{
          margin: '5px 10px',
        }}
        variant="subtitle2"
        noWrap
      >
        {t('smartmessaging.contentEditor.notify.content')}
      </Typography>
      <ValidityAdornment
        valid={!contentValidity.contentIsEmpty}
        message={t('smartmessaging.contentEditor.notify.contentIsEmpty')}
      />
    </div>
  );
};

NotifyContentLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  contentValidity: state.massAction.contentValidity,
});

export default connect(mapStateToProps, {})(NotifyContentLabel);
